<template>
    <div class="innerBox">
  
      <h1>Not Being Worked On</h1>
      <h5>Laporan pekerjaan yang tidak dilanjutkan pada tanggal yang dipilih.</h5>
  
      <panel class="border border-secondary mt-3" :noExpand="true">
        <template slot="header">
          <h4 class="panel-title">Filter</h4>
        </template>
        <div class="row outerBox filterBox">
          <div class="col row">
            <!-- <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Cari</label>
              <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
            </div> -->
            <div class="col-md-4 col-12" :class="mobile ? 'pt-20' : ''">
              <label for="partshopCode">Tanggal</label>
              <flat-pickr
                v-model="filter.date"
                :config="rangeConfig"
                placeholder="Pilih Tanggal"
              ></flat-pickr>
            </div>
            <div class="col-md-4 col-12" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
            </div>
          </div>
        </div>
      </panel>
  
      <vue-universal-table
        api_url="/api/v1/workorder/report/notWorkedOnToday"
        :special_buttons="vue_universal_table.special_buttons"
        :disable_sort="true"
        :update="vue_universal_table.update"
        :filter="filter"
        :export_config="vue_universal_table.export_config"
      ></vue-universal-table>
  
    </div>
  </template>
  
  <script>  
    import moment from 'moment'
    import Multiselect from 'vue-multiselect'
    export default {
      components : {
        Multiselect
      },
      data () {
        let start = moment().format('Y-MM-DD')

        return {
          mobile : this.isMobile(),
          modal : {
            view : false,
          },
          rangeConfig: {
            altInput: true,
            altInputClass: 'form-control input flatpickr-input w-100',
            animate: !this.isRTL()
          },
          detailId : '',
          filter : {
            date : start,
          },
          vue_universal_table : {
            special_buttons : [],
            update : 0,
            export_config : {
              name : 'Outstanding Estimation',
              type : 'xlsx',
              all : true
            },
            fields : [{
              title : "Nomor Work Order",
              variable : 'nomor_wo'
            },{
              title : "Nomor Polisi",
              variable : 'nomor_polisi'
            },{
              title : "Customer Name",
              variable : 'customer_name'
            },{
              title : "Waktu Work Order Dibuat",
              variable : 'tanggal_wo_dibuat',
              date_format : 'MMM DD, Y HH:mm'
            },{
              title : "Waktu Estimasi Pertama Dibuat",
              variable : 'tanggal_estimasi_dibuat',
              date_format : 'MMM DD, Y HH:mm'
            }]
          },
          dummyData : null,
          insuranceCompany : null
        }
      },
      mounted () {
      },
      methods : {
        viewDetail(a){
          console.log(JSON.parse(a).form_code);
          this.detailId = JSON.parse(a).form_code;
          this.modal.view = true;
        },
        generateData(){
            var names = ['Apple', 'Orange', 'Lemon', 'Kiwi', 'Pear']
            var dummy = []
            for(var i = 0; i < 15; i++){
                dummy.push({
                    woNumber : this.randomInt(1000000, 10000000),
                    total_sparepart : this.randomInt(1, 10),
                    total_price : this.randomInt(100000, 10000000),
                    insurance_name : names[this.randomInt(0,4)],
                    customer_name : names[this.randomInt(0,4)],
                })
            }
            this.dummyData = dummy
        },
      }
    }
  </script>
  
  <style scoped>
  
  </style>